import { color } from '@upstox/upstox-ui';

export const container: CSSFunction = () => ({
  width: '100%',
});

export const button: CssStyles = {
  borderRadius: '4px',
  cursor: 'pointer',
  fontSize: '12px',
  fontWeight: '400',
  lineHeight: '1',
  height: '32px',
  padding: '8px 32px',
  gap: '4px',
  alignItems: 'center',
};

export const NoButton: CSSFunction = ({ theme }) => ({
  ...button,
  backgroundColor: color(theme, 'interactive.danger.default'),
  color: color(theme, 'interactive.primary.default'),
  border: `1px solid ${color(theme, 'interactive.primary.default')}`,
});

export const YesButton: CSSFunction = ({ theme }) => ({
  ...button,
  backgroundColor: color(theme, 'interactive.primary.default'),
  color: color(theme, 'text.3'),
});
